import React, { FC } from 'react';
import { StepRenderer, useHasComponent, useOrchestratorState } from '@wix/gg-components/orchestrator';
import { Box, Loader } from '@wix/design-system';
import { HeaderLogo } from 'components/Header/HeaderLogo';
import styles from './App.scss';
import { Header } from 'components/Header/Header';
import clsx from 'clsx';
import { StepParams, StepRenderPart } from 'types/steps';
import { useIsMobile } from 'hooks/useIsMobile';

export const AppLayout: FC = () => {
  const { isLoading, currentParams } = useOrchestratorState<StepParams>();
  const isMobile = useIsMobile();
  const mainComponent = useHasComponent<StepRenderPart>('main');
  const sideComponent = useHasComponent<StepRenderPart>('side');
  const sideRatio = currentParams?.sideRatio || 'half';

  if (isLoading) {
    return (
      <Box align="center" verticalAlign="middle" height="100vh" width="100vw">
        <Box direction="vertical" align="center" gap={10}>
          <HeaderLogo />
          <Loader />
        </Box>
      </Box>
    );
  }

  if (!mainComponent && !sideComponent) {
    return <StepRenderer />;
  }

  return (
    <div className={styles.appLayout}>
      <div className={styles.appLayoutHeader}>
        <Header />
      </div>
      <div className={styles.appLayoutContent}>
        <div className={clsx(styles.appLayoutContentMain, !isMobile && styles[sideRatio])}>
          <StepRenderer componentKey="main" />
        </div>
        {!isMobile && (
          <div className={clsx(styles.appLayoutContentSide, styles[sideRatio])}>
            <div className={styles.appLayoutContentSideInner}>
              <StepRenderer componentKey="side" />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
